import React from 'react'
import { Spinner } from 'react-bootstrap'
import PropTypes from 'prop-types'

const Loader = ({ message }) => {
  return (
    <div className='text-center'>
      <Spinner animation="border" role="status" />
      <div className='mb-3'>{message}</div>
    </div>
  )
}

Loader.propTypes = {
  message: PropTypes.string
}

export default Loader